import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

const CurrencyField = ({ currency = '€', endAdornment, value, onChange, ...props }) => {
	// Compute the formatted display value from the numeric value prop.
	const displayValue =
		value !== null && value !== undefined && value !== ""
			? Number(value).toLocaleString()
			: "";
        
	const handleChange = (event) => {
		let input = event.target.value;
		// Remove any commas before validation
		const rawValue = input.replace(/,/g, '');
		// Allow only numbers with an optional decimal point and up to 2 decimal places
		if (/^\d*\.?\d{0,2}$/.test(rawValue)) {
			// Format with commas if value exceeds 1000
			if (rawValue && parseFloat(rawValue) >= 1000) {
				let parts = rawValue.split('.');
				parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
				input = parts.join('.');
			} else {
				input = rawValue;
			}
			if (onChange) {
				// Return numeric value while maintaining display formatting.
				onChange(rawValue !== "" ? parseFloat(rawValue) : null);
			}
		}
	};

	return (
		<TextField
			variant="filled"
			size='small'
			// Remove MUI default background for filled inputs.
			sx={{
				'& .MuiFilledInput-root': {
					backgroundColor: 'white !important'
				},
				'& input:focus': { border: 'none' },
				'& input': { border: 'none' },
			}}
			value={displayValue}
			onChange={handleChange}
			slotProps={{
				input: {
					startAdornment: (
						<InputAdornment position="start">{currency}</InputAdornment>
					 ),
					// Conditionally add right side adornment
					...(
						endAdornment && {
							endAdornment: (
								<InputAdornment position="end" >
									{endAdornment}
								</InputAdornment>
							)
						}
					)
				},
				htmlInput: { inputMode: 'decimal' } // added for mobile number keyboard
			}}
			{...props}
		/>
	);
};

export default CurrencyField;